/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useState } from "react";

import { Plate } from "src/classes/plate/Plate";
import { PlateSettings } from "src/components/Plate/Settings";
import { TopbarTextButton } from "src/components/Plate/ShareMenu/ShareButton";

interface Props {
  plate: Plate;
}
export const SettingsButton = ({ plate }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <TopbarTextButton onClick={() => setOpen(true)}>SETTINGS</TopbarTextButton>
      {open && <PlateSettings setModalOpen={setOpen} plate={plate} />}
    </>
  );
};
